<div class='headerContainer' id='headerContainer'>
	<div class='brandHeader'>
		<header id='brandHeader'></header>
	</div>
</div>
<div class="container-fluids ">
	<div class="row col1HeaderAlign">
		<div *ngIf="appConfig?.region==='US'" class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
			<h1 class="col1Header">PAYMENT CALCULATOR</h1>
		</div>
		<div *ngIf="appConfig?.region==='CA'" class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
			<h1 class="col1Header">PAYMENT ESTIMATOR</h1>
		</div>
	</div>
	<div class="row">
		<div class="col-xs-12 col-sm-12 page-title-desc col1HeaderAlign">
			<div class="NoteContent">{{appConfig?.paymentCaldesc}}</div>
		</div>
	</div>
</div>
<router-outlet></router-outlet>
<div id='footerContainer'>
	<div class='brandFooter'>
		<footer id='brandFooter'></footer>
	</div>
</div>

